import { Action } from '@ngrx/store';
import * as _ from 'lodash';
import { MissingSideMembers } from './state-models/missing-side-members';

export enum MissingSideMembersActions {
    LoadMissingSideMembersPageAction='[ MissingSideMembers ] Load missing side members',  
    ChangeMissingSideMembersPageAction='[ MissingSideMembers ] Change missing side members',
    ChangeMissingSideMembersSortExpressionAction='[ MissingSideMembers ] Change Sort Expression',
    ChangeMissingSideMembersFilterExpressionAction='[ MissingSideMembers ] Change Filter Expression',
    ChangeMissingSideMembersTotalCountAction='[ MissingSideMembers ] Total Count Expression'
}

export class ChangeMissingSideMembersSortExpressionAction implements Action {
    readonly type = MissingSideMembersActions.ChangeMissingSideMembersSortExpressionAction;
    constructor(public payload: string) { }
}

export class ChangeMissingSideMembersFilterExpressionAction implements Action {
    readonly type = MissingSideMembersActions.ChangeMissingSideMembersFilterExpressionAction;
    constructor(public payload: string) { }
}

export class ChangeMissingSideMembersTotalCountAction implements Action {
    readonly type = MissingSideMembersActions.ChangeMissingSideMembersTotalCountAction;
    payload: { totalCount: number};
    constructor(totalCount: number) {
        this.payload = { totalCount};
    }
}

export class ChangeMissingSideMembersPageAction implements Action {
    readonly type = MissingSideMembersActions.ChangeMissingSideMembersPageAction;
    constructor(public payload: number) { }
}

export class LoadMissingSideMembersPageAction implements Action {
    readonly type = MissingSideMembersActions.LoadMissingSideMembersPageAction;
    constructor(public payload: MissingSideMembers[]) { }
}


export type MissingSideMembersAction =
    | LoadMissingSideMembersPageAction   
    | ChangeMissingSideMembersSortExpressionAction
    | ChangeMissingSideMembersFilterExpressionAction
    | ChangeMissingSideMembersTotalCountAction
    | ChangeMissingSideMembersPageAction
    ;
